"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Input;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _InputModule = _interopRequireDefault(require("./Input.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Input.propTypes = {
  autoFocus: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['email', 'number', 'password', 'tel', 'text']).isRequired,
  input: _propTypes.default.object,
  meta: _propTypes.default.object,
  placeholder: _propTypes.default.string,
  marked: _propTypes.default.bool
};
Input.defaultProps = {
  defaultValue: '',
  input: {
    value: ''
  },
  meta: {},
  type: 'text'
};

function Input(_ref) {
  var _classNames;

  var autoFocus = _ref.autoFocus,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      input = _ref.input,
      marked = _ref.marked,
      meta = _ref.meta,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      rounded = _ref.rounded,
      type = _ref.type;
  var active = meta.active,
      touched = meta.touched,
      error = meta.error,
      warning = meta.warning,
      submitFailed = meta.submitFailed,
      submitting = meta.submitting;
  var classes = (0, _classnames.default)(_InputModule.default.Input, (_classNames = {}, _defineProperty(_classNames, _InputModule.default.error, (touched || submitFailed || submitting) && error), _defineProperty(_classNames, _InputModule.default.warning, (touched || submitFailed || submitting) && warning), _defineProperty(_classNames, _InputModule.default.marked, marked), _defineProperty(_classNames, _InputModule.default.active, active), _defineProperty(_classNames, _InputModule.default.rounded, rounded), _classNames));
  return _react.default.createElement("input", _extends({}, input, {
    autoFocus: autoFocus,
    value: input.value || defaultValue,
    type: type,
    placeholder: placeholder,
    readOnly: readOnly,
    disabled: disabled,
    className: classes
  }));
}

//# sourceMappingURL=Input.js.map